import {Injectable} from "@angular/core";
import {throwError} from "rxjs";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AttendantsWithGroupsBff} from "../interfaces/manual-transfer.interface";
import {environment} from "../../../../environments/environment";
import {generateRequestTimeLogHeader} from "../../../core/interceptors/log.interceptor";

@Injectable({
  providedIn: 'root',
})
export class AttendantService {

  constructor(
    private readonly httpClient: HttpClient
  ) {
  }

  public getCompanyAttendantsWithGroups(companyId: string) {
    if (!companyId) return throwError(() => new Error('company id is required'));

    const params = new HttpParams()
      .appendAll({'companiesIds': [companyId]})

    return this.httpClient.get<AttendantsWithGroupsBff>(
      `${environment.externalUrls.bff}/attendants/with-groups`,
      {
        headers: generateRequestTimeLogHeader('get-company-attendants-with-groups'),
        params
      }
    );
  }
}
